"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REACT_SELECT_WRAPPER_DEFAULT_THEME = exports.REACT_SELECT_WRAPPER_DEFAULT_STYLES = void 0;
const BLACK = "black";
const WHITE = "white";
const GRAY = "#d9d9d9";
const LIGHT_GRAY = "#f4f4f4";
exports.REACT_SELECT_WRAPPER_DEFAULT_STYLES = {
    container: (provided) => (Object.assign(Object.assign({}, provided), { width: "100%" })),
    control: (provided) => (Object.assign(Object.assign({}, provided), { background: WHITE, boxShadow: null, textAlign: "left", padding: "0px 0px 0px 12px", cursor: "text" })),
    valueContainer: (provided) => (Object.assign(Object.assign({}, provided), { padding: "0px" })),
    input: (provided) => (Object.assign(Object.assign({}, provided), { margin: "0px", padding: "0px", color: BLACK })),
    placeholder: (provided) => (Object.assign(Object.assign({}, provided), { margin: "0px" })),
    indicatorSeparator: () => ({
        display: "none",
    }),
    indicatorsContainer: (provided) => (Object.assign(Object.assign({}, provided), { padding: "0px" })),
    menu: (provided) => (Object.assign(Object.assign({}, provided), { margin: "0px", backgroundColor: WHITE })),
    option: (provided, { isFocused, isSelected }) => (Object.assign(Object.assign({}, provided), { color: BLACK, cursor: "pointer", backgroundColor: isSelected ? GRAY : isFocused ? LIGHT_GRAY : undefined })),
    menuPortal: (base) => (Object.assign(Object.assign({}, base), { zIndex: 9999 })),
};
const REACT_SELECT_WRAPPER_DEFAULT_THEME = (theme) => (Object.assign(Object.assign({}, theme), { colors: {
        neutral40: GRAY,
        neutral30: GRAY,
        neutral20: GRAY,
        primary: GRAY, // Bordure focus
    } }));
exports.REACT_SELECT_WRAPPER_DEFAULT_THEME = REACT_SELECT_WRAPPER_DEFAULT_THEME;
//# sourceMappingURL=reactSelectDefaultStyles.js.map